module.exports = __webpack_public_path__ + "img/position.611e6d5d.png";